import React,{useState,useRef, useCallback} from 'react';
import {DialogActions,DialogContent,Paper,Button,Dialog,TextField,IconButton,Typography,Tooltip} from '@material-ui/core';
import Draggable from 'react-draggable';
import { ValidatorForm} from 'react-material-ui-form-validator';
import {axiosPostAction,axiosResponse} from'../../../Gfunc'
import { useStyles,paperPropsSmallTall } from '../../../css/muiStyle';
import { Add ,Close} from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { AlertCompo } from '../../../js/components';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { withStyles} from '@material-ui/core/styles';
import { mdiPlusBox } from '@mdi/js';
import Icon from '@mdi/react';

const styles = (theme) => ({
  root: {
    margin: 0,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top:0,
    color:'white',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle  className={classes.root} {...other}>
      <Typography >{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <Close />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

//add new marque
function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  )
}

export default function Ref_pck_addToPack(props) {
    const classes=useStyles();
    const Gfunc=require('../../../Gfunc')
    const [open, setOpen] =useState(false);
    const [mtn,setMtn]=useState(0);
    const [qte,setQte]=useState(1);
    const [prod,setProd]=useState('');
    const [prodL,setProdL]=useState([]);
    const [openA, setOpenA] =useState(false);
    const [message, setMessage] =useState('');
    const [severity, setSeverity] =useState('info');
    const service="_pck.php"

    
    const handleAlert=(openA,severity,message)=>{
      setOpenA(openA)
      setSeverity(severity)
      setMessage(message)
      setTimeout(function(){
        setOpenA(false)
      }, 5000);
    }

 
    const handleClickOpen = () => { 
      setQte(1);
      setMtn(0);
      fetchProd();
      setOpen(true); 
    };

    const handleClose = () => { setOpen(false); };
    
    const handleSubmit= async(e) =>{
        const data={
          packId:props.id,
          produitId:prod,
          qte:parseFloat(qte),
          mtn:parseFloat(mtn)
        }
        const respon=await axiosPostAction(service,"adddet",data)
        if(respon.data.err&&respon.data.err!=='-1'){
          handleAlert(true,'error',respon.data.err)
        }else
        axiosResponse(respon,()=>{
                setOpen(false);
                if (respon.data.jData){
                  const elem = document.getElementById("m"+props.id).innerHTML.replace(/\s/g, '')
                  Gfunc.updateElem("m"+props.id,parseFloat(elem)+parseFloat(mtn))
                  props.handleAlert(true,"success","Un nouveau produit été ajouté au pack")
                  props.callback(props.id);
                }
        })
    }

    //fetch Products
const fetchProd= useCallback(async(serv="_prd.php", act = "gets") => {
  const response = await Gfunc.axiosGetAction(serv,act);
  if(response.data.err&&response.data.err!=='-1'){
     handleAlert(true,'error',response.data.err)
  }else{
  Gfunc.axiosResponse(response,()=>{
    if(response.data.jData){
      setProdL(response.data.jData); 
    }   
  })
}
},[Gfunc])

  return (
    <div>
      <Tooltip title="Ajouter une vente ">
        <Add className={classes.blackIcon} onClick={handleClickOpen}/>
      </Tooltip>
      <Dialog
            open={open}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            PaperProps={paperPropsSmallTall}
      >
        <DialogTitle className={classes.topDivTitle} onClose={handleClose}>
            <div className='DialogTitle'>
              <Icon path={mdiPlusBox} size={1} />
              <label>Ajouter vente dans {props.pack}</label>
            </div>
        </DialogTitle>
        <AlertCompo severity={severity} open={openA} setOpen={setOpenA} message={message} dialg={true}/>
        <DialogContent>
           <ValidatorForm ref={useRef(null)} onSubmit={handleSubmit} id="formPack" onError={errors => console.log(errors)} >
                <Autocomplete
                    disableClearable
                    id="iProd"
                    onChange={(e,newValue) =>{setProd(newValue.id)}} 
                    className='smallAuto'
                    options={prodL}
                    getOptionLabel={(option) => option.nom}
                    getOptionSelected={(option, value) => option.id === value.id}
                    renderInput={(params) => (
                        <TextField {...params} variant='outlined' label={'Produit'} size="small" required/>
                )}/>
            
                 <TextField margin="dense"  label={"Qte"} size="small" type='number' value={qte} variant="outlined" className='smallText'
                            id="iqte" onChange={e =>setQte(e.target.value)} required/>

                 <TextField margin="dense"  label={"Montant"} size="small" type='number' value={mtn} variant="outlined" className='smallText'
                            id="iMtn" onChange={e =>setMtn(e.target.value)} required/>
          </ValidatorForm>                                   
        </DialogContent>
        <DialogActions>
          <Button variant="contained" type='submit' color="primary" form="formPack" startIcon={<Add />}>Ajouter</Button>
        </DialogActions>
      </Dialog>
      </div>
  );
}